(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/wager/assets/javascripts/wager.js') >= 0) return;  svs.modules.push('/components/lb-utils/wager/assets/javascripts/wager.js'); 
'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var logger = new svs.core.log.Logger('component:core.wager');
svs.lbUtils = svs.lbUtils || {};
svs.lbUtils.wager = svs.lbUtils.wager || {};
var data = svs.lbUtils.wager ? svs.lbUtils.wager.data : {};
var trackGAWager = svs.utils.trackGAWager;
var roles = svs.core.userSession.roles;
var simpleProductName = {
  MAL: 'Måltipset',
  STRYK: 'Stryktipset',
  TMIX: 'Challenge',
  ITA: 'Europatipset',
  T8STRYK: 'Topptipset',
  T8EXTRA: 'Topptipset',
  T8: 'Topptipset',
  POWERPLAY: 'Powerplay',
  BOMBEN: 'Bomben',
  MIXEN: 'Oddset Mixen',
  LIVE: 'Oddset Live',
  MATCHEN: 'Matchen',
  RX: 'Sputnik'
};
var productName = {
  MAL: 'Måltipset',
  STRYK: 'Stryktipset',
  TMIX: 'Challenge',
  ITA: 'Europatipset',
  T8STRYK: 'Topptipset Stryktipset',
  T8EXTRA: 'Topptipset Extra',
  T8: 'Topptipset',
  POWERPLAY: 'Powerplay',
  BOMBEN: 'Bomben',
  MIXEN: 'Oddset Mixen',
  LIVE: 'Oddset Live',
  MATCHEN: 'Matchen',
  SPORTJOKER: 'Sportkrysset',
  RX: 'Sputnik'
};

var wager = function () {
  var _this = this;

  var makePayment = function makePayment(accountbalance) {
    _this.balance = svs.utils.format.CurrencyFromJupiterString(accountbalance);

    if (!_this.wagerprops || !_this.wagerprops.productId) {
      throw new Error('No productId provided');
    }

    if (_this.wagerprops.marketplaceAccount && !_this.wagerprops.marketplaceAccount.activatedDrawId) {
      throw new Error('MarketplaceAccount provided without activatedDrawId');
    }

    if (_this.wagerprops.marketplaceAccount) {
      _this.wagerprops.extradata = _this.wagerprops.extradata || {};
      _this.wagerprops.extradata.shares = true;

      switch (svs.core.session.data.userSession.role) {
        case roles.PLAYER:
          _this.wagerprops.extradata.typeOfShares = 'c2c';
          break;

        default:
          _this.wagerprops.extradata.typeOfShares = 'r2c';
      }
    } 


    _this.payObject = {
      method: 'POST',
      path: _this.wagerprops.marketplaceAccount ? "/marketplace/1/activateddraws/".concat(_this.wagerprops.marketplaceAccount.activatedDrawId, "/wagers") : '/wager/wagers',
      data: _this.wager
    }; 

    if (svs.lbUtils.wager.data && _.isEqual(_this.wager, svs.lbUtils.wager.data.lastwager) && new moment().diff(svs.lbUtils.wager.data.lastwagertime, 'seconds') < 3) {
      svs.events.publish('/loader/hide');
      logger.info('doubleclick payment attempt');
      return false;
    }

    svs.lbUtils.wager.data = {
      lastwager: _this.wager,
      lastwagertime: new moment()
    };
    var bet = {},
        stryk;

    switch (_this.wagerprops.productId) {
      case 'TMIX':
        _.each(_this.wager.bets, function (bet) {
          _this.trackingWager.totalPrice += svs.utils.format.CurrencyFromJupiterString(bet.betAmountSalesGroup1);
        });

        bet = {
          productName: productName[_this.wagerprops.productId],
          productId: _this.wagerprops.productId,
          price: svs.utils.format.CurrencyFromJupiterString(_this.wager.bets[0].betAmountSalesGroup1),
          numberOfRows: 1,
          extraData: _this.wagerprops.extradata
        };

        _this.trackingWager.bets.push(bet);

        break;

      case 'MAL':
      case 'STRYK':
        {
          _.each(_this.wager.bets, function (bet) {
            _this.trackingWager.totalPrice += svs.utils.format.CurrencyFromJupiterString(bet.betAmountSalesGroup1);
          });

          var strykdata = _.find(_this.wager.bets, {
            productId: _this.wagerprops.productId
          });

          stryk = {
            productName: productName[_this.wagerprops.productId],
            productId: _this.wagerprops.productId,
            price: svs.utils.format.CurrencyFromJupiterString(strykdata.betAmountSalesGroup1),
            numberOfRows: 1,
            extraData: _this.wagerprops.extradata
          };

          _this.trackingWager.bets.push(stryk);

          if (_this.wager.bets.length > 1) {
            var sportkryssdata = _.find(_this.wager.bets, function (bet) {
              return bet.productId !== _this.wagerprops.productId;
            });

            var sportkryss = {
              productName: productName[sportkryssdata.productId],
              productId: sportkryssdata.productId,
              price: svs.utils.format.CurrencyFromJupiterString(sportkryssdata.betAmountSalesGroup1),
              numberOfRows: 1,
              extraData: undefined
            };

            _this.trackingWager.bets.push(sportkryss);
          }

          break;
        }

      case 'ITA':
      case 'T8STRYK':
      case 'T8EXTRA':
      case 'T8':
      case 'POWERPLAY':
      case 'BOMBEN':
      case 'MIXEN':
      case 'MATCHEN':
      case 'RX':
        bet = {
          productName: productName[_this.wagerprops.productId],
          productId: _this.wagerprops.productId,
          price: svs.utils.format.CurrencyFromJupiterString(_this.wager.bets[0].betAmountSalesGroup1),
          numberOfRows: 1,
          extraData: _this.wagerprops.extradata
        };
        _this.trackingWager.totalPrice = bet.price;

        _this.trackingWager.bets.push(bet);

        break;

      default:
    } 


    var betAmount = svs.utils.format.CurrencyFromJupiterString(_this.trackingWager.totalPrice);

    if (_this.wagerprops.betAmount) {
      betAmount = _this.wagerprops.betAmount;
    }

    if (Object.prototype.hasOwnProperty.call(_this, 'balance') && betAmount > _this.balance && !_this.wager.voucherId) {
      svs.events.publish('/loader/hide');

      _this.abortCallback();

      showNoMoneyMessage.call(_this, _this.balance, betAmount);
    } else {
      svs.events.publish('/loader/hide'); 

      if (_this.wagerprops.message) {
        var onPay = function onPay() {
          svs.components.dialog.api.close();

          if (_this.wagerprops.competitionSignUp) {
            if (svs.competition.Helper.userIsParticipatingInTipsSM()) {
              _this.payObject.data.competitionId = [_this.wagerprops.competitionSignUp.id];
              _this.payObject.data.bets[0].betProperties = _this.payObject.data.bets[0].betProperties || [];

              _this.payObject.data.bets[0].betProperties.push('COMPETITION');

              if (_this.payObject.data.bets.length > 1 && _this.payObject.data.bets[1].productId === 'SPORTJOKER') {
                _this.payObject.data.bets[1].betProperties = _this.payObject.data.bets[1].betProperties || [];

                _this.payObject.data.bets[1].betProperties.push('COMPETITION');
              }

              sendWager();
            } else {
              competitionSignUp();
            }
          } else {
            sendWager();
          }
        };

        var onAbort = function onAbort() {
          svs.components.dialog.api.close();
          togglePayButton(true);
          svs.lbUtils.wager.data = {};
          svs.events.publish('/payment/cancel');

          _this.abortCallback();
        };

        if (typeof _this.wagerprops.message === 'string') {
          var oldOutdatedVersionOfDialog = {
            branding: svs.components.dialog.branding.SPORT,
            icon: 'games',
            title: 'Betala',
            message: [{
              type: svs.components.dialog.message.TEXT,
              text: _this.wagerprops.message
            }],
            actions: [{
              title: 'Avbryt',
              callback: onAbort
            }, {
              title: 'Betala',
              callback: onPay
            }]
          };
          togglePayButton(false);
          svs.components.dialog.api.add(new svs.components.dialog.Confirm(oldOutdatedVersionOfDialog));
        } else {
          var validationDialog = _this.wagerprops.message.title ? svs.components.dialog.Confirm : svs.components.dialog.Payment;
          var dialogConfig = {
            branding: svs.components.dialog.branding.SPORT,
            icon: 'games',
            actions: [{
              title: 'Avbryt',
              callback: onAbort
            }, {
              title: 'Betala',
              callback: onPay
            }]
          };

          if (_this.wagerprops.message.title) {
            dialogConfig.title = _this.wagerprops.message.title;
          } else {
            dialogConfig.price = _this.wagerprops.message.price;
            dialogConfig.product = _this.wagerprops.message.product;
          }

          _this.wagerprops.message.messages.forEach(function (message) {
            if (!dialogConfig.message) {
              dialogConfig.message = [];
            }

            dialogConfig.message.push({
              type: svs.components.dialog.message.TEXT,
              text: message
            });
          });

          togglePayButton(false);
          svs.components.dialog.api.add(new validationDialog(dialogConfig));
        }
      } else {
        sendWager();
      }
    }
  };

  var sendWager = function sendWager() {
    svs.events.publish('/loader/show');
    svs.core.jupiter.call(_this.payObject, function (data) {
      togglePayButton(true);

      if (!data.wagerClientSerial) {
        data.wagerClientSerial = data.CreateWagerReply && data.CreateWagerReply.serial;
      }

      logger.info("success wagerid:".concat(data.wagerClientSerial, ", product:").concat(productName[_this.wagerprops.productId]));
      _this.trackingWager.wagerId = data.wagerClientSerial;

      if (!_this.wagerprops.noAccountbalanceUpdate) {
        svs.components.account_balance.set(svs.utils.format.CurrencyFromJupiterString(data.accountBalance));
      }

      trackGAWager(_this.trackingWager);
      svs.events.publish('/loader/hide');

      _this.successCallback(data);
    }, function (jqXHR, textStatus, errorThrown) {
      togglePayButton(true);
      logger.warn("failure (".concat(JSON.stringify(jqXHR), ", ").concat(textStatus, ", ").concat(errorThrown, ")"));
      var response = JSON.parse(jqXHR.responseText);
      svs.events.publish('/loader/hide');
      var errorcode;

      if (response.error && !response.error.code) {
        errorcode = 1;
        response.error.code = '1';
      } else if (typeof response.error.code === 'number') {
        errorcode = response.error.code;
      } else {
        errorcode = parseInt(response.error.code.replace(/\s/g, ''), 10);
      }

      switch (errorcode) {
        case 28109:
          svs.components.dialog.api.add(new svs.components.dialog.Confirm({
            branding: svs.components.dialog.branding.SPORT,
            icon: 'my-limits',
            type: svs.components.dialog.type.ERROR,
            title: 'Du har uppnått en gräns',
            message: [{
              type: svs.components.dialog.message.TEXT,
              text: 'Du kan därför inte betala spelet.'
            }],
            actions: [{
              title: 'Mina gränser',
              type: svs.components.dialog.button.SECONDARY,
              callback: function callback() {
                location.href = svs.utils.urlMapping.get('myProfileLimits');
              }
            }, {
              title: 'Stäng',
              type: svs.components.dialog.button.SECONDARY
            }]
          }));
          break;

        case 5117:
        case 6235:
          svs.sport.sport_common.showErrorDialog('Något gick tyvärr fel', 'Försök igen om en stund.');
          break;

        case 1019:
        case 5135:
          showSuspensionMessage();
          break;

        case 6149:
          svs.components.dialog.api.add(new svs.components.dialog.Confirm({
            branding: svs.components.dialog.branding.SPORT,
            icon: 'spelpaus',
            type: svs.components.dialog.type.ERROR,
            title: 'Ditt konto är spärrat',
            message: [{
              type: svs.components.dialog.message.TEXT,
              text: 'Kontakta kundservice för mer information.'
            }],
            actions: [{
              title: 'Kundservice',
              type: svs.components.dialog.button.SECONDARY,
              callback: function callback() {
                location.href = svs.utils.urlMapping.get('customerServiceHome');
              }
            }, {
              title: 'Stäng',
              type: svs.components.dialog.button.SECONDARY
            }]
          }));
          break;

        case 6121:
          showNoMoneyMessage.call(_this, _this.balance);
          break;

        case 8222:
        case 8223:
        case 8225:
        case 8226:
        case 8228:
        case 8229:
          _this.abortCallback();

          svs.components.dialog.api.add(new svs.components.dialog.Confirm({
            branding: svs.components.dialog.branding.SPORT,
            icon: 'my-limits',
            type: svs.components.dialog.type.ERROR,
            title: 'Du har överskridit en gräns',
            message: [{
              type: svs.components.dialog.message.TEXT,
              text: 'Högsta totala insats på omgången har överskridits.'
            }],
            actions: [{
              title: 'OK'
            }]
          }));
          break;

        case 6332:
          _this.abortCallback();

          showKycMessage();
          break;

        case 8224:
        case 8227:
        case 8230:
          svs.components.dialog.api.add(new svs.components.dialog.Confirm({
            branding: svs.components.dialog.branding.SPORT,
            icon: 'my-limits',
            type: svs.components.dialog.type.ERROR,
            title: 'Du har överskridit en gräns',
            message: [{
              type: svs.components.dialog.message.TEXT,
              text: 'Högsta totala dagliga insats på denna produkt har överskridits.'
            }],
            actions: [{
              title: 'OK'
            }]
          }));
          break;

        case 8239:
        case 8240:
          svs.components.dialog.api.add(new svs.components.dialog.Confirm({
            branding: svs.components.dialog.branding.SPORT,
            icon: 'my-limits',
            type: svs.components.dialog.type.ERROR,
            title: 'Du har överskridit en gräns',
            message: [{
              type: svs.components.dialog.message.TEXT,
              text: 'Högsta antalet rader på denna omgång har överskridits.'
            }],
            actions: [{
              title: 'OK'
            }]
          }));
          break;

        default:
          _this.errorCallback(response);

      }
    });
  };

  var competitionSignUp = function competitionSignUp() {
    logger.info("Sign up to competition: ".concat(_this.wagerprops.competitionSignUp.id, " from core/wager"));
    var compSignupData = {
      method: 'PUT',
      path: "/competition/competitions/".concat(_this.wagerprops.competitionSignUp.id, "/participations"),
      data: {
        teamId: 0,
        signupType: 'PARTICIPATE',
        targetCustomerId: 0,
        scopeType: 'INDIVIDUAL_ONLY',
        invitationId: 0,
        locationId: 0
      }
    };
    async.series([function (callback) {
      svs.competition.core.acceptTerm(svs.competition.core.data.tipsSMRulesAndTerms[0], callback);
    }, function (callback) {
      svs.core.jupiter.call(compSignupData, function (response) {
        callback(null, response);
      }, function (error) {
        callback(error);
      });
    }], function (error, results) {
      if (error) {
        logger.error('Anmälan till Tips-SM gick inte bra', error);
        svs.sport.sport_common.showErrorDialog('Något gick tyvärr fel', 'Försök igen om en stund.');
      } else {
        logger.debug('Anmälan till Tips-SM gick bra', results);
        _this.payObject.data.competitionId = [_this.wagerprops.competitionSignUp.id];
        _this.payObject.data.bets[0].betProperties = _this.payObject.data.bets[0].betProperties || [];

        _this.payObject.data.bets[0].betProperties.push('COMPETITION');

        sendWager();
      }
    });
  };

  var sendOddsetWagers = function sendOddsetWagers() {
    logger.info('sendOddsetWagers : ', _this.wagers);
    _this.live_result_urls = [];
    _this.payObject = {
      method: 'POST',
      path: '/wager/multiwagers',
      data: _this.wagers
    };
    svs.events.publish('/loader/show');
    svs.core.jupiter.call(_this.payObject, function (data) {
      logger.info("Payoddset response received (".concat(JSON.stringify(data), ")"));
      var delay = 0;
      _this.regWagerResponse = data;

      _.each(_this.regWagerResponse.regWagerResults, function (regWagerResult, index) {
        if (regWagerResult.status === 'SUCCESS') {
          delay = regWagerResult.regWagerResult.delayTime <= delay ? delay : regWagerResult.regWagerResult.delayTime;
          var url = "/wager/wagers/livebetresult?wagerSerials=[\"".concat(regWagerResult.regWagerResult.wagerClientSerial, "\"]");

          _this.live_result_urls.push({
            url: url,
            id: regWagerResult.regWagerResult.wagerClientSerial
          });
        } else {
          logger.info("regWager ".concat(index, " failed with status=").concat(regWagerResult.status));
        }
      });

      if (delay > 0) {
        _this.payObject = {
          method: 'GET',
          path: "/multifetch?serial=true&urls=".concat(_.pluck(_this.live_result_urls, 'url').join('|'))
        };
        delay = delay * 1000;
        verifyLiveBets(delay);
      } else {
        togglePayButton(true);
        var balance = -1;

        _.each(_this.regWagerResponse.regWagerResults, function (regWagerResult, index) {
          if (regWagerResult.status === 'SUCCESS') {
            _this.trackingWagers[index].wagerId = regWagerResult.regWagerResult.wagerClientSerial;
            balance = svs.utils.format.CurrencyFromJupiterString(regWagerResult.regWagerResult.accountBalance);
            trackGAWager(_this.trackingWagers[index]);
          }
        });

        if (balance > -1) {
          svs.components.account_balance.set(balance);
        }

        svs.events.publish('/loader/hide');
        svs.components.Storage.browser.remove('wagerstart', 'Wager', function () {});

        _this.successCallback(data);
      }
    }, function (jqXHR, textStatus, errorThrown) {
      var errorCode = 777,
      response;

      if (jqXHR.responseText) {
        response = JSON.parse(jqXHR.responseText);

        if (response.error && typeof response.error.code === 'string') {
          errorCode = parseInt(response.error.code.replace(/\s/g, ''), 10);
        }
      }

      logger.warn("Payoddset failure (".concat(errorCode, ", ").concat(JSON.stringify(jqXHR), ", ").concat(textStatus, ", ").concat(errorThrown, ")"));

      switch (errorCode) {
        case 28109:
          svs.components.dialog.api.add(new svs.components.dialog.Confirm({
            branding: svs.components.dialog.branding.SPORT,
            icon: 'my-limits',
            type: svs.components.dialog.type.ERROR,
            title: 'Du har uppnått en gräns',
            message: [{
              type: svs.components.dialog.message.TEXT,
              text: 'Du kan därför inte betala spelet.'
            }],
            actions: [{
              title: 'Mina gränser',
              type: svs.components.dialog.button.SECONDARY,
              callback: function callback() {
                location.href = svs.utils.urlMapping.get('myProfileLimits');
              }
            }, {
              title: 'Stäng',
              type: svs.components.dialog.button.SECONDARY
            }]
          }));
          break;

        case 5117:
        case 6235:
          svs.sport.sport_common.showErrorDialog('Något gick tyvärr fel', 'Försök igen om en stund.');
          break;

        case 1019:
        case 5135:
          showSuspensionMessage();
          break;

        case 6332:
          showKycMessage();
          break;

        case 6149:
          svs.components.dialog.api.add(new svs.components.dialog.Confirm({
            branding: svs.components.dialog.branding.SPORT,
            icon: 'spelpaus',
            type: svs.components.dialog.type.ERROR,
            title: 'Ditt konto är spärrat',
            message: [{
              type: svs.components.dialog.message.TEXT,
              text: 'Kontakta kundservice för mer information.'
            }],
            actions: [{
              title: 'Kundservice',
              type: svs.components.dialog.button.SECONDARY,
              callback: function callback() {
                location.href = svs.utils.urlMapping.get('customerServiceHome');
              }
            }, {
              title: 'Stäng',
              type: svs.components.dialog.button.SECONDARY
            }]
          }));
          break;

        case 6121:
          showNoMoneyMessage.call(_this, _this.balance);
          break;

        case 8222:
        case 8223:
        case 8225:
        case 8226:
        case 8228:
        case 8229:
          svs.components.dialog.api.add(new svs.components.dialog.Confirm({
            branding: svs.components.dialog.branding.SPORT,
            icon: 'my-limits',
            type: svs.components.dialog.type.ERROR,
            title: 'Du har överskridit en gräns',
            message: [{
              type: svs.components.dialog.message.TEXT,
              text: 'Högsta totala insats på omgången har överskridits.'
            }],
            actions: [{
              title: 'OK'
            }]
          }));
          break;

        case 8224:
        case 8227:
        case 8230:
          svs.components.dialog.api.add(new svs.components.dialog.Confirm({
            branding: svs.components.dialog.branding.SPORT,
            icon: 'my-limits',
            type: svs.components.dialog.type.ERROR,
            title: 'Du har överskridit en gräns',
            message: [{
              type: svs.components.dialog.message.TEXT,
              text: 'Högsta totala dagliga insats på denna produkt har överskridits.'
            }],
            actions: [{
              title: 'OK'
            }]
          }));
          break;

        default:
          if (errorCode === 777) {
            var responseOut = {};
            responseOut.regWagerResults = [{
              status: 'FAILURE',
              regWagerResult: null,
              error: {
                code: errorCode
              }
            }];
            svs.components.Storage.browser.remove('wagerstart', 'Wager', function () {});

            _this.errorCallback(responseOut);
          } else {
            svs.components.Storage.browser.remove('wagerstart', 'Wager', function () {});

            _this.errorCallback(response);
          }

      }

      togglePayButton(true);
      svs.events.publish('/loader/hide');
      svs.components.Storage.browser.remove('wagerstart', 'Wager', function () {});
    });
  };

  var verifyLiveBets = function verifyLiveBets(delay) {
    logger.info("Verifying livebets in = ".concat(delay, "ms"), _this.payObject);
    var resend = false;
    setTimeout(function () {
      logger.info("".concat(delay, "ms passed, calling /wager/wagers/livebetresult"));
      svs.core.jupiter.call(_this.payObject, function (data) {
        delay = 0;

        _.each(data.responses, function (response, index) {
          var errObj = {
            status: 'FAILURE',
            regWagerResult: null,
            error: ''
          };

          if (response.error || !response.liveBetResult || response.liveBetResult.length === 0) {
            logger.info('Livebet with error', response.error);
            errObj.error = response.error;
            _this.regWagerResponse.regWagerResults[index] = errObj;
          } else {
            if (response.liveBetResult[0].status === 'ACTIVE') {
              logger.info('Livebet needs to be verified again', response.liveBetResult[0]);
              resend = true; 

              delay = isNaN(response.liveBetResult[0].remainingDelay) || response.liveBetResult[0].remainingDelay < 100 ? 100 : response.liveBetResult[0].remainingDelay;
            } else if (response.liveBetResult[0].status === 'NONE') {
              logger.info('Livebet with status NONE', response.liveBetResult);

              _.each(_this.regWagerResponse.regWagerResults, function (regWagerResult, wagerindex) {
                if (regWagerResult.regWagerResult && regWagerResult.regWagerResult.wagerClientSerial && _this.live_result_urls.length > index) {
                  if (regWagerResult.regWagerResult.wagerClientSerial === _this.live_result_urls[index].id) {
                    errObj.tpError = createOddsetLiveErrorObject(response.liveBetResult[0]);
                    _this.regWagerResponse.regWagerResults[wagerindex] = errObj;
                  }
                } else {
                  logger.warn('Missing regWagerResult on wager', regWagerResult);
                  errObj.tpError = createOddsetLiveErrorObject(response.liveBetResult[0]);
                  _this.regWagerResponse.regWagerResults[wagerindex] = errObj;
                }
              });
            } else if (response.liveBetResult[0].status === 'CANCELLED') {
              logger.info('Livebet with status CANCELLED', response.liveBetResult);

              _.each(_this.regWagerResponse.regWagerResults, function (regWagerResult, wagerindex) {
                if (regWagerResult.regWagerResult && regWagerResult.regWagerResult.wagerClientSerial) {
                  if (regWagerResult.regWagerResult.wagerClientSerial === _this.live_result_urls[index].id) {
                    errObj.tpError = createOddsetLiveErrorObject(response.liveBetResult[0]);
                    _this.regWagerResponse.regWagerResults[wagerindex] = errObj;
                  }
                } else {
                  logger.warn('Missing regWagerResult on wager', regWagerResult);
                  errObj.tpError = createOddsetLiveErrorObject(response.liveBetResult[0]);
                  _this.regWagerResponse.regWagerResults[wagerindex] = errObj;
                }
              });
            } else {
              logger.info("Livebet with status ".concat(response.liveBetResult[0].status));
            }
          }
        });

        if (resend) {
          verifyLiveBets(delay);
        } else {
          logger.info("Verifying livebets done (".concat(JSON.stringify(_this.regWagerResponse), ")"));
          var balance = -1;

          _.each(_this.regWagerResponse.regWagerResults, function (regWagerResult, index) {
            if (regWagerResult.status === 'SUCCESS') {
              _this.trackingWagers[index].wagerId = regWagerResult.regWagerResult.wagerClientSerial;
              balance = svs.utils.format.CurrencyFromJupiterString(regWagerResult.regWagerResult.accountBalance);
              trackGAWager(_this.trackingWagers[index]);
            }
          });

          if (balance > -1) {
            svs.components.account_balance.set(balance);
          }

          svs.events.publish('/loader/hide');
          svs.components.Storage.browser.remove('wagerstart', 'Wager', function () {
            togglePayButton(true);
          });

          _this.successCallback(_this.regWagerResponse);
        }
      }, function (jqXHR, textStatus, errorThrown) {
        var responseOut = {};
        var responseIn = {},
            errorCode = 888; 

        logger.warn("Verifying livebets failed (".concat(JSON.stringify(jqXHR), ", ").concat(textStatus, ", ").concat(errorThrown, ")"));

        if (jqXHR.responseText) {
          responseIn = JSON.parse(jqXHR.responseText);

          if (responseIn.error && typeof responseIn.error.code === 'string') {
            errorCode = parseInt(responseIn.error.code.replace(/\s/g, ''), 10);
          }
        }

        if (errorCode === 6149) {
          svs.components.dialog.api.add(new svs.components.dialog.Confirm({
            branding: svs.components.dialog.branding.SPORT,
            icon: 'spelpaus',
            type: svs.components.dialog.type.ERROR,
            title: 'Ditt konto är spärrat',
            message: [{
              type: svs.components.dialog.message.TEXT,
              text: 'Kontakta kundservice för mer information.'
            }],
            actions: [{
              title: 'Kundservice',
              type: svs.components.dialog.button.SECONDARY,
              callback: function callback() {
                location.href = svs.utils.urlMapping.get('customerServiceHome');
              }
            }, {
              title: 'Stäng',
              type: svs.components.dialog.button.SECONDARY
            }]
          }));
        } else if (errorCode === 5135 || errorCode === 1019) {
          showSuspensionMessage();
        } else if (errorCode === 6332) {
          showKycMessage();
        } else {
          responseOut.regWagerResults = [{
            status: 'FAILURE',
            regWagerResult: null,
            error: {
              code: errorCode
            }
          }];
          svs.components.Storage.browser.remove('wagerstart', 'Wager', function () {});

          _this.errorCallback(responseOut);
        }

        togglePayButton(true);
        svs.events.publish('/loader/hide');
        svs.components.Storage.browser.remove('wagerstart', 'Wager', function () {});
      });
    }, delay);
  };

  var handleNotEnoughMoney = function handleNotEnoughMoney(betAmount) {
    svs.events.publish('/loader/hide');
    showNoMoneyMessage(_this.balance, betAmount);
  };

  var createOddsetLiveErrorObject = function createOddsetLiveErrorObject(liveBetResult) {
    return {
      facility: 8,
      errCode: liveBetResult.errCode,
      errDesc: liveBetResult.errDesc,
      details: liveBetResult.details
    };
  };


  var showSuspensionMessage = function showSuspensionMessage(extraInfo) {
    var options = {
      method: 'GET',
      path: '/player/suspensions'
    };

    var errorFn = function errorFn() {
      logger.error('Error fetching users suspensions');
      svs.components.dialog.api.add(new svs.components.dialog.Confirm({
        branding: svs.components.dialog.branding.SPORT,
        icon: 'spelpaus',
        title: 'Du har en aktiv spelpaus',
        message: [{
          type: svs.components.dialog.message.TEXT,
          text: "G\xE5 till Spelpaus f\xF6r att l\xE4sa mer."
        }],
        actions: [{
          title: 'Spelpaus',
          callback: function callback() {
            location.href = svs.utils.urlMapping.get('gamingResponsibilityPause');
          }
        }, {
          title: 'OK'
        }]
      }));
    };

    var successFn = function successFn(response) {
      var activeSuspension = response.suspensions.filter(function (suspension) {
        return suspension.product === 'all' || suspension.product === 'quickGames';
      }); 

      activeSuspension.forEach(function (suspension) {
        suspension.duration = Math.round(moment(suspension.validTo || suspension.terminable).diff(moment(suspension.validFrom), 'months', true));
      }); 

      svs.components.dialog.api.add(new svs.components.dialog.Confirm({
        branding: svs.components.dialog.branding.SPORT,
        icon: 'spelpaus',
        message: [{
          type: svs.components.dialog.message.TEXT,
          text: svs.components.customer_login.templates.suspension_message({
            suspensions: activeSuspension,
            extraInfo: extraInfo ? extraInfo : ''
          })
        }],
        actions: [{
          title: 'OK'
        }]
      }));

      _this.abortCallback();
    };

    svs.core.jupiter.call(options, successFn, errorFn);
  };


  var showKycMessage = function showKycMessage() {
    svs.core.module.load('/cl/components/kyc-messages', null, function () {
      svs.components.kyc_messages.showKYCMessage();
    });
  };

  return {
    pay: function pay(wager, wagerprops, successCallback, errorCallback, abortCallback) {
      if (typeof abortCallback !== 'function') {
        abortCallback = function abortCallback() {};
      }

      logger.debug("paywager wager:".concat(JSON.stringify(wager)));
      logger.debug("paywager wagerprops:".concat(JSON.stringify(wagerprops)));
      _this.trackingWager = {
        productName: simpleProductName[wagerprops.productId],
        wagerId: 0,
        totalPrice: 0,
        bets: []
      };
      _this.wager = wager;
      _this.wagerprops = wagerprops;
      _this.successCallback = successCallback;
      _this.errorCallback = errorCallback;
      _this.abortCallback = abortCallback;
      _this.balance = 0;
      togglePayButton(false); 

      if (!svs.core.userSession.hasRole(roles.PLAYER) && !svs.core.userSession.hasRole(roles.RETAILER)) {
        svs.components.customer_login.login({
          returnNewCustomer: true
        });
      } else {
        svs.events.publish('/loader/show');

        if (_this.wagerprops && _this.wagerprops.marketplaceAccount) {
          _.defer(_.bind(makePayment, _this, _this.wagerprops.marketplaceAccount.balance));
        } else {
          svs.components.account_balance.get(true, makePayment);
        }
      }
    },
    togglePayButton: function togglePayButton(on) {
      var payButton = $('.js-btn-pay');

      if (on && payButton.prop('disabled')) {
        payButton.prop('disabled', false);
      } else {
        payButton.prop('disabled', true);
      }
    },
    cancel: function cancel(wagerid, messageConfig, successCallback, errorCallback, productId, wager) {
      var overrideOptions = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};

      if (_typeof(overrideOptions) !== 'object') {
        throw new Error('Expected overrideOptions to be of type object');
      }

      var options = _objectSpread({}, {
        path: "/wager/wagers/".concat(wagerid)
      }, {}, overrideOptions); 


      if (!svs.core.userSession.hasRole(roles.PLAYER)) {
        svs.components.account_balance.on('change', function (accountbalance) {
          _this.balance = svs.utils.format.CurrencyFromJupiterString(accountbalance);
        }); 

        svs.components.customer_login.login();
      } else if (!isNaN(wagerid)) {
        var cancelObject = {
          method: 'DELETE',
          path: options.path
        };
        var trackingCancelWager = {
          wagerId: wagerid,
          totalPrice: 0,
          bets: []
        };

        if (messageConfig) {
          var validationDialogConfig = {
            branding: svs.components.dialog.branding.SPORT,
            icon: 'help',
            title: messageConfig.title,
            actions: [{
              title: 'Avbryt'
            }, {
              title: 'Annullera',
              callback: function callback() {
                svs.components.dialog.api.close();
                svs.events.publish('/loader/show');
                svs.core.jupiter.call(cancelObject, function (data) {
                  logger.info("cancelwager success wagerid:".concat(wagerid, ", productId").concat(productId));
                  var total = data && data.wagerAmounts && data.wagerAmounts.totalAmount;

                  if (!total) {
                    total = data && data.CancelWagerReply && data.CancelWagerReply.betAmount;
                  }

                  total = svs.utils.format.CurrencyFromJupiterString(total) * -1;

                  if (wager) {
                    switch (productId) {
                      case 'MAL':
                      case 'STRYK':
                        {
                          var strykdata = _.find(wager.bets, {
                            productId: productId
                          });

                          var stryk = {
                            productName: productName[productId],
                            productId: "".concat(productId, ".Annullering"),
                            price: svs.utils.format.CurrencyFromJupiterString(strykdata.betAmountSalesGroup1) * -1,
                            numberOfRows: 1
                          };
                          trackingCancelWager.bets.push(stryk);

                          if (wager.bets.length > 1) {
                            var sportkryssdata = _.find(wager.bets, function (bet) {
                              return bet.productId !== productId;
                            });

                            var sportkryss = {
                              productName: productName[sportkryssdata.productId],
                              productId: "".concat(sportkryssdata.productId, ".Annullering"),
                              price: svs.utils.format.CurrencyFromJupiterString(sportkryssdata.betAmountSalesGroup1) * -1,
                              numberOfRows: 1
                            };
                            trackingCancelWager.bets.push(sportkryss);
                          }

                          break;
                        }

                      default:
                        {
                          var betdata = _.where(wager.bets || wager.wager.bets || [], {
                            productId: productId
                          });

                          betdata = betdata[0];
                          var betinfo = {
                            productName: productName[productId],
                            productId: "".concat(productId, ".Annullering"),
                            price: svs.utils.format.CurrencyFromJupiterString(betdata.betAmountSalesGroup1) * -1,
                            numberOfRows: 1
                          };
                          trackingCancelWager.bets.push(betinfo);
                        }
                    }
                  } else {
                    var bet = {};

                    if (productId) {
                      bet = {
                        productName: productName[productId],
                        productId: "".concat(productId, ".Annullering"),
                        price: total,
                        numberOfRows: 1
                      };
                    } else {
                      bet = {
                        productName: 'Okänd',
                        productId: 'Okänd.Annullering',
                        price: total,
                        numberOfRows: 1
                      };
                    }

                    trackingCancelWager.bets.push(bet);
                  }

                  trackingCancelWager.totalPrice = total;
                  trackGAWager(trackingCancelWager);
                  svs.events.publish('/loader/hide');
                  svs.components.account_balance.get(true);
                  successCallback(data);
                }, function (jqXHR, textStatus, errorThrown) {
                  logger.warn("cancelwager failure (".concat(JSON.stringify(jqXHR), ", ").concat(textStatus, ", ").concat(errorThrown, ")"));
                  var response = JSON.parse(jqXHR.responseText);
                  svs.events.publish('/loader/hide');
                  errorCallback(response);
                });
              }
            }]
          };

          if (messageConfig.message) {
            validationDialogConfig.message = [{
              type: svs.components.dialog.message.TEXT,
              text: messageConfig
            }];
          }

          svs.components.dialog.api.add(new svs.components.dialog.Confirm(validationDialogConfig));
        }
      }
    },
    payOddset: function payOddset(accountBalance, wagers, wagerprops, successCallback, errorCallback) {
      if (!svs.core.userSession.hasRole(roles.PLAYER)) {
        svs.components.customer_login.login({
          returnNewCustomer: true
        });
      } else {
        if (svs.lbUtils.wager.data && _.isEqual(wagers, svs.lbUtils.wager.data.lastwager) && new moment().diff(svs.lbUtils.wager.data.lastwagertime, 'seconds') < 3) {
          logger.info('Oddset doubleclick payment attempt');
          togglePayButton(true);
          svs.events.publish('/wager/paymentAborted');
          return false;
        }

        _this.wagers = {
          wagers: wagers
        };
        _this.wagerprops = wagerprops;
        _this.successCallback = successCallback;
        _this.errorCallback = errorCallback;
        togglePayButton(false);
        _this.balance = 0;
        _this.trackingWagers = [];
        _this.balance = svs.utils.format.CurrencyFromJupiterString(accountBalance);
        svs.lbUtils.wager.data = {
          lastwager: wagers,
          lastwagertime: new moment()
        };

        _.each(_this.wagers.wagers, function (wager, index) {
          var trackingwager = {
            productName: simpleProductName[_this.wagerprops.productId],
            wagerId: 0,
            totalPrice: 0,
            bets: []
          };
          var bet = {
            productName: productName[wagerprops[index].productId],
            productId: wagerprops[index].productId,
            price: svs.utils.format.CurrencyFromJupiterString(wager.bets[0].betAmountSalesGroup1),
            numberOfRows: 1,
            extraData: wagerprops[index].extradata
          };
          trackingwager.totalPrice += bet.price;
          trackingwager.bets.push(bet);

          _this.trackingWagers.push(trackingwager);
        });

        _this.payObject = {
          method: 'POST',
          path: '/wager/multiwagers',
          data: _this.wagers
        }; 

        var betAmount = 0;

        if (wagerprops[0].betAmount) {
          betAmount = wagerprops[0].betAmount;
        }

        if (betAmount > _this.balance) {
          handleNotEnoughMoney(betAmount);
        } else {
          if (wagerprops[0].message) {
            var oldOutdatedVersionOfDialog = {
              branding: svs.components.dialog.branding.SPORT,
              icon: 'games',
              title: 'Betala',
              message: [{
                type: svs.components.dialog.message.TEXT,
                text: wagerprops[0].message
              }],
              actions: [{
                title: 'Avbryt',
                callback: function callback() {
                  svs.components.dialog.api.close();
                  svs.components.Storage.browser.remove('wagerstart', 'Wager', function () {});
                  togglePayButton(true);
                  svs.events.publish('/wager/paymentAborted');
                  svs.lbUtils.wager.data = {};
                }
              }, {
                title: 'Betala',
                callback: function callback() {
                  svs.components.dialog.api.close();
                  svs.components.Storage.browser.set('wagerstart', 'Wager', 1, svs.components.Storage.constants.EXPIRES_10M, function () {});
                  sendOddsetWagers();
                }
              }]
            };
            togglePayButton(false);
            svs.components.dialog.api.add(new svs.components.dialog.Confirm(oldOutdatedVersionOfDialog));
            logger.info('Oddset validation: ', wagerprops[0].message);
          }
        }
      }
    },
    handleNotEnoughMoney: handleNotEnoughMoney,
    showSuspensionMessage: showSuspensionMessage,
    isPaymentOngoing: function isPaymentOngoing() {
      return svs.components.Storage.browser.get('wagerstart', 'Wager');
    },
    showKycMessage: showKycMessage,
    abortWager: abortWager
  };
}();

function abortWager(abortWagerCallback) {
  svs.components.Storage.browser.remove('wagerstart', 'Wager', function () {
    svs.events.publish('/wager/paymentAborted');
    togglePayButton(true);

    if (abortWagerCallback && _.isFunction(abortWagerCallback)) {
      abortWagerCallback();
    }
  });
}

function showTransfer() {
  svs.components.Storage.browser.remove('wagerstart', 'Wager', function () {});
  svs.utils.form.postToUrl('/overforingar', {
    returnUrl: window.location
  });
}

function togglePayButton(on) {
  var payButton = $('.js-btn-pay');

  if (on && payButton.is(':disabled')) {
    payButton.attr('disabled', false);
  } else if (!on && payButton.is(':enabled')) {
    payButton.attr('disabled', true);
  }
}

function showNoMoneyMessage(balance, betAmount) {
  var isMarketplace = this && this.wagerprops && this.wagerprops.marketplaceAccount,
      hasBalance = balance !== undefined,
      hasCost = betAmount,
      cost = hasCost ? svs.utils.format.Currency(betAmount) : null,
      title = isMarketplace ? 'Ni har inte tillräckligt mycket pengar för att betala det här spelet' : 'Du har inte tillräckligt med pengar på ditt spelkonto för att betala ditt spel.',
      messages = [];
  balance = hasBalance ? svs.utils.format.Currency(balance) : null;

  if (hasBalance) {
    if (isMarketplace) {
      messages.push("Att spela f\xF6r: ".concat(balance, " kr"));
    } else {
      messages.push("Saldo: ".concat(balance, " kr"));
    }
  }

  if (hasCost) {
    messages.push("Pris: ".concat(cost, " kr"));
  }

  var dialogConfig = {
    branding: svs.components.dialog.branding.SPORT,
    icon: 'balance',
    title: title,
    actions: []
  };

  if (messages.length) {
    dialogConfig.message = [{
      type: svs.components.dialog.message.TEXT,
      text: messages.join('<br />')
    }];
  }

  if (isMarketplace) {
    dialogConfig.actions.push({
      title: 'OK',
      callback: function callback() {
        svs.components.dialog.api.close();
        abortWager();
      }
    });
  } else {
    dialogConfig.actions.push({
      title: 'Avbryt',
      callback: function callback() {
        svs.components.dialog.api.close();
        abortWager();
      }
    });
    dialogConfig.actions.push({
      title: 'Sätt in',
      callback: function callback() {
        svs.components.dialog.api.close();
        showTransfer();
      }
    });
  }

  svs.components.dialog.api.add(new svs.components.dialog.Confirm(dialogConfig));
}

wager.data = data;
svs.lbUtils.wager = wager;
 })(window);